import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import styles from './ErrorScreen.css';

function ErrorScreen({ fallbackPath, fallbackLabel }) {
    return (
        <section className={styles.root}>
            <h1 className={styles.title}>
                Something went wrong
            </h1>
            <p className={styles.label}>
                An unexpected error occurred. Please go back to your dashboard and try again.
            </p>
            <div className={styles.actions}>
                <Button
                    label={fallbackLabel}
                    link={{ to: fallbackPath }}
                />
            </div>
        </section>
    );
}

ErrorScreen.propTypes = {
    fallbackPath: PropTypes.string.isRequired,
    fallbackLabel: PropTypes.string.isRequired
};

export {
    ErrorScreen
};
